import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PageCard = ({ children, fluid, ...props }) => (
  <div
    {...props}
    className={classnames('PageCard container-fluid', props.className, {
      'container-fluid': fluid,
      container: !fluid
    })}
  >
    {children}
  </div>
);

PageCard.defaultProps = {
  className: null,
  fluid: false
};

PageCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string,
  fluid: PropTypes.bool
};

export default PageCard;
